import { render, staticRenderFns } from "./ModalCadastroValor.vue?vue&type=template&id=6c216203"
import script from "./ModalCadastroValor.vue?vue&type=script&lang=js"
export * from "./ModalCadastroValor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports